(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-video-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* --- Video autoplay on click --- */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        var card = entry.target;
        var wrap = card.querySelector('[data-ws-video-wrap]');
        var template = card.querySelector('[data-ws-video-template]');
        var poster = card.querySelector('[data-ws-poster]');
        var playBtn = card.querySelector('[data-ws-play-btn]');

        if (!template || !wrap) return;

        var playVideo = function() {
          var content = template.content.cloneNode(true);
          var video = content.querySelector('video');

          if (video) {
            video.setAttribute('playsinline', '');
            video.setAttribute('preload', 'metadata');
            wrap.appendChild(video);

            video.play().then(function() {
              if (poster) poster.classList.add('ws_video-grid__poster--hidden');
              if (playBtn) playBtn.classList.add('ws_video-grid__play--hidden');
            }).catch(function() {});
          }

          template.remove();
          observer.unobserve(card);
        };

        if (playBtn) {
          playBtn.addEventListener('click', playVideo, { once: true });
        }
      });
    }, {
      rootMargin: '200px'
    });

    document.querySelectorAll('[data-ws-video-card]').forEach(function(card) {
      observer.observe(card);
    });

    /* --- Show More / Show Less toggle --- */
    document.querySelectorAll('[data-ws-show-more-btn]').forEach(function(btn) {
      var section = btn.closest('[data-ws-video-section]');
      if (!section) return;

      var grid = section.querySelector('[data-ws-video-grid]');
      if (!grid) return;

      var labelMore = btn.getAttribute('data-label-more');
      var labelLess = btn.getAttribute('data-label-less');
      var expanded = false;

      btn.addEventListener('click', function() {
        expanded = !expanded;
        grid.classList.toggle('ws_video-grid__grid--expanded', expanded);
        btn.textContent = expanded ? labelLess : labelMore;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
